<template>
  <div class="loading">
    <div class="binding"></div>
    <div class="pad">
      <div class="line line1"></div>
      <div class="line line2"></div>
      <div class="line line3"></div>
      <div class="line line4"></div>
      <div class="line line5"></div>
      <div class="line line6"></div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.loading
  width 400px
  position absolute
  top -40px
  left  50%
  -webkit-transform translateY(-50%) translateX(-50%)
  -moz-transform translateY(-50%) translateX(-50%)
  -o-transform translateY(-50%) translateX(-50%)
  transform translateY(-50%) translateX(-50%)


  .binding
    content ''
    width 54px
    height 12px
    background-color white
    border 2px solid #707070
    margin 0 auto

  .pad
    width 54px
    height 56px
    background-color white
    box-shadow 1px 1px 8px 0px #6f6f6f
    border 2px solid #707070
    border-top  0
    padding 6px
    margin 0 auto

  .line
    width 38px
    margin-top 6px
    border-top 2px solid #495490
    opacity 0
    -webkit-animation writeline 3.5s infinite ease-in
    -moz-animation writeline 3.5s infinite ease-in
    -o-animation writeline 3.5s infinite ease-in
    animation writeline 3.5s infinite ease-in

    &:first-child
      margin-top 0

    for num in (0..5)
      &{num+1}
        -webkit-animation-delay (0+(num * 0.5))s
        -moz-animation-delay (0+(num * 0.5))s
        -o-animation-delay (0+(num * 0.5))s
        animation-delay (0+(num * 0.5))s

@-webkit-keyframes writeline {
  0% { width : 0px; opacity: 0; }
  33% { width : 38px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}

@-moz-keyframes writeline {
  0% { width : 0px; opacity: 0; }
  33% { width : 38px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}

@-o-keyframes writeline {
  0% { width : 0px; opacity: 0; }
  33% { width : 38px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}

@keyframes writeline {
  0% { width : 0px; opacity: 0; }
  33% { width : 38px; opacity : 1; }
  70% { opacity : 1; }
  100% {opacity : 0; }
}
</style>
